import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../utils/AuthContext";
import UserNavbar from "../../components/UserNavbar";
import Footer from "../../components/Footer";
import SideBar from "./components/SideBar";
import { DocumentProvider } from "../../contexts/DocumentContext";
import { TourProvider } from "../../contexts/TourContext";
import ProductTour from "../../components/ProductTour";
import HelpCentreModal from "../../modals/HelpCentreModal";
import ContactModal from "../../modals/ContactModal";
import AuthSkeleton from "../../components/SkeletonLoading/AuthSkeleton";

const Home: React.FC = () => {
  const { isLoading } = useAuth();
  const [isHelpCentreModalOpen, setIsHelpCentreModalOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  if (isLoading) return <AuthSkeleton />;

  return (
    <TourProvider>
      <DocumentProvider>
        <div className="flex flex-col h-screen overflow-hidden">
          <UserNavbar onMenuClick={() => setIsMobileSidebarOpen(true)} />
          <div className="flex flex-1 overflow-hidden bg-[#1d365d]">
            <SideBar
              onHelpCentreClick={() => setIsHelpCentreModalOpen(true)}
              isMobileOpen={isMobileSidebarOpen}
              onMobileClose={() => setIsMobileSidebarOpen(false)}
            />
            <main className="flex-1 flex flex-col overflow-hidden bg-[#f8fafc] lg:rounded-tl-[20px]">
              <Outlet />
              <Footer />
            </main>
          </div>
        </div>
        <HelpCentreModal
          isOpen={isHelpCentreModalOpen}
          setIsOpen={setIsHelpCentreModalOpen}
          onContactClick={() => {
            setIsHelpCentreModalOpen(false);
            setIsContactModalOpen(true);
          }}
        />
        <ContactModal
          isOpen={isContactModalOpen}
          setIsOpen={setIsContactModalOpen}
        />
        <ProductTour />
      </DocumentProvider>
    </TourProvider>
  );
};

export default Home;
